export const navigateExternal = (destiny: string) => {
    window.open(destiny, "_blank");
  }